import React from "react";
import styles from "./booking-flow-layout.module.css";

type BookingFlowNarrowContentProps = {
    children: React.ReactNode;
    className?: string;
};

/** Matches HPV recommendation step inset inside the embedded shell. */
const BookingFlowNarrowContent: React.FunctionComponent<BookingFlowNarrowContentProps> = ({
    children,
    className,
}) => {
    return (
        <div
            className={[styles.narrowContent, className]
                .filter(Boolean)
                .join(" ")}
        >
            {children}
        </div>
    );
};

export default BookingFlowNarrowContent;
